export default __webpack_public_path__ + "static/media/q_wdt_c_2.34d69f2f.mp3";